/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBluetoothOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m2.707 1.293 20 20-1.414 1.414-4.793-4.793-5.5 5.5v-8.669l-3.331 2.998-1.338-1.486 4.48-4.032-9.518-9.518zM13 14.413v4.173l2.086-2.086zM11 .587l7.452 7.452-3.158 2.84-1.416-1.414 1.67-1.502L13 5.414v3.172l-2-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBluetoothOff as BluetoothOff };
